(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/engine/assets/javascripts/create-coupons.js') >= 0) return;  svs.modules.push('/components/tipsen/engine/assets/javascripts/create-coupons.js'); "use strict";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
const {
  COUPON_STANDARD,
  COUPON_SINGLEROWS,
  COUPON_EXTERNAL_SYSTEM,
  COUPON_XPERT
} = svs.components.tipsen.engine.constants.couponTypes;
const {
  SYSTEM_MSYS
} = svs.components.tipsen.engine.constants.systems;
const {
  BOARD_MULTIPLE,
  BOARD_SINGLE
} = svs.components.tipsen.engine.constants.boardType;
const {
  getOutcomesForEventType
} = svs.components.sport.tipsenShared;
const {
  getDefinitionByProduct
} = svs.components.tipsen.engine.utils;
const {
  generateSportkryssNumber
} = svs.components.tipsen.engine.utils;
const createBoard = (draw, type, engineDefinition) => {
  const eventTypeId = engineDefinition.outcomes.eventTypeId;
  const sportType = draw.sportType;
  const signs = getOutcomesForEventType(eventTypeId, sportType, false);
  const userSigns = getOutcomesForEventType(eventTypeId, sportType, false);
  const signDistribution = getOutcomesForEventType(eventTypeId, sportType, 0);
  return {
    type,
    pixSize: null,
    pixVariant: null,
    signs: draw.drawEvents.map(() => signs.slice()),
    userSigns: draw.drawEvents.map(() => userSigns.slice()),
    signDistribution: draw.drawEvents.map(() => signDistribution.slice()),
    uSigns: draw.drawEvents.map(() => null),
    mSigns: draw.drawEvents.map(() => false)
  };
};
const createStandardCoupon = _ref => {
  var _engineDefinition$def, _engineDefinition$def2, _engineDefinition$sys, _engineDefinition$def3, _engineDefinition$def4;
  let {
    draw,
    engineDefinition
  } = _ref;
  return {
    productId: draw.productId,
    drawNumber: draw.drawNumber,
    boards: [createBoard(draw, BOARD_MULTIPLE, engineDefinition)],
    betAmountIndex: (_engineDefinition$def = (_engineDefinition$def2 = engineDefinition.defaultCouponValues) === null || _engineDefinition$def2 === void 0 ? void 0 : _engineDefinition$def2.betAmountIndex) !== null && _engineDefinition$def !== void 0 ? _engineDefinition$def : 0,
    sportkryss: 0,
    sportkryssNumber: generateSportkryssNumber(),
    selectedAddonPixIndex: 0,
    week: 0,
    uSystem: null,
    rSystem: null,
    selectedSystem: engineDefinition.systems.indexOf(SYSTEM_MSYS),
    lastSelectedSystemType: engineDefinition.systems.indexOf((_engineDefinition$sys = engineDefinition.systems.filter(sys => sys !== SYSTEM_MSYS)[0]) !== null && _engineDefinition$sys !== void 0 ? _engineDefinition$sys : 0),
    reduceModeCount: (_engineDefinition$def3 = (_engineDefinition$def4 = engineDefinition.defaultCouponValues) === null || _engineDefinition$def4 === void 0 ? void 0 : _engineDefinition$def4.reduceModeCount) !== null && _engineDefinition$def3 !== void 0 ? _engineDefinition$def3 : 0
  };
};
const createSingleRowsCoupon = _ref2 => {
  var _engineDefinition$def5, _engineDefinition$def6, _engineDefinition$def7, _engineDefinition$def8;
  let {
    draw,
    engineDefinition
  } = _ref2;
  const singleRowsCoupon = {
    productId: draw.productId,
    drawNumber: draw.drawNumber,
    boards: [],
    betAmountIndex: (_engineDefinition$def5 = (_engineDefinition$def6 = engineDefinition.defaultCouponValues) === null || _engineDefinition$def6 === void 0 ? void 0 : _engineDefinition$def6.betAmountIndex) !== null && _engineDefinition$def5 !== void 0 ? _engineDefinition$def5 : 0,
    sportkryss: 0,
    sportkryssNumber: generateSportkryssNumber(),
    week: 0,
    uSystem: null,
    rSystem: null,
    selectedSystem: engineDefinition.systems.indexOf(SYSTEM_MSYS),
    reduceModeCount: (_engineDefinition$def7 = (_engineDefinition$def8 = engineDefinition.defaultCouponValues) === null || _engineDefinition$def8 === void 0 ? void 0 : _engineDefinition$def8.reduceModeCount) !== null && _engineDefinition$def7 !== void 0 ? _engineDefinition$def7 : 0
  };
  for (let i = 0; i < 12; ++i) {
    singleRowsCoupon.boards.push(createBoard(draw, BOARD_SINGLE, engineDefinition));
  }
  return singleRowsCoupon;
};
const createExternalCoupon = _ref3 => {
  let {
    draw,
    engineDefinition
  } = _ref3;
  return _objectSpread(_objectSpread({}, createSingleRowsCoupon({
    draw,
    engineDefinition
  })), {}, {
    isExternal: true,
    isTransferable: false,
    boards: []
  });
};
const createPixCoupon = _ref4 => {
  let {
    draw,
    engineDefinition
  } = _ref4;
  return {
    productId: draw.productId,
    drawNumber: draw.drawNumber,
    boards: [createBoard(draw, BOARD_MULTIPLE, engineDefinition)],
    betAmountIndex: 0,
    sportkryss: 0,
    sportkryssNumber: generateSportkryssNumber(),
    week: 0,
    uSystem: null,
    rSystem: null,
    selectedSystem: engineDefinition.systems.indexOf(SYSTEM_MSYS),
    reduceModeCount: undefined,
    selectedAddonPixIndex: 0
  };
};
const createCoupons = _ref5 => {
  let {
    draws,
    engineDefinition
  } = _ref5;
  const coupons = {};
  for (const draw of Object.values(draws)) {
    const drawId = "".concat(draw.productId, "_").concat(draw.drawNumber);
    if (draw.isLite) {
      const pixEngineDefintion = getDefinitionByProduct(draw.productId);
      const drawToUse = _objectSpread(_objectSpread({}, draw), {}, {
        drawEvents: new Array(13).fill(null)
      });
      coupons["".concat(drawId, "_").concat(COUPON_XPERT)] = createPixCoupon({
        draw: drawToUse,
        engineDefinition: pixEngineDefintion
      });
      continue;
    }
    coupons["".concat(drawId, "_").concat(COUPON_STANDARD)] = createStandardCoupon({
      draw,
      engineDefinition
    });
    coupons["".concat(drawId, "_").concat(COUPON_SINGLEROWS)] = createSingleRowsCoupon({
      draw,
      engineDefinition
    });
    coupons["".concat(drawId, "_").concat(COUPON_EXTERNAL_SYSTEM)] = createExternalCoupon({
      draw,
      engineDefinition
    });
  }
  return coupons;
};
setGlobal('svs.components.tipsen.engine', {
  createCoupons,
  createPixCoupon,
  createExternalCoupon,
  createSingleRowsCoupon,
  createStandardCoupon
});
 })(window);